<!--
 * @Description: 说明
 * @version: 版本
 * @Author: 作者
 * @Date: 2020-07-27 11:24:40
 * @LastEditTime: 2024-11-25 10:24:43
-->
<template>
  <div id="app" :class="{ 'has-app-top-nav': showAppTopNav }">
    <AppTabs></AppTabs>
    <AppTopNav />
    <!-- 始终单一 router-view：勿用 v-if 切换两套 view，否则进入页 setKeepPages 后 keepPages 从空变非空会整页重建，created/接口会重复执行 -->
    <keep-alive :include="keepPages" max="2">
      <router-view class="app_content" />
    </keep-alive>
    <!-- <GlobalBackBtn /> -->
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import AppTabs from "@/components/appTabs/index.vue";
import GlobalBackBtn from "@/components/com/GlobalBackBtn.vue";
import AppTopNav from "@/components/com/AppTopNav.vue";
import { isAppTopNavVisible } from "@/utils/appTopNav";
export default {
  name: "App",
  components: { AppTabs, GlobalBackBtn, AppTopNav },

  data() {
    return {};
  },
  computed: {
    ...mapState(["keepPages"]),
    showAppTopNav() {
      return isAppTopNavVisible(this.$route);
    },
  },
  mounted() {
    this.doQueryHelpSellers();
  },
  methods: {
    ...mapActions(["setHelpSellerIds"]),

    async doQueryHelpSellers() {
      try {
        const { code, ret } = await $http.get("auxiliaryOperationWhite");
        if (code == 200 && ret && ret.length) {
          this.setHelpSellerIds(ret);
        }
      } catch (error) {
        console.error('auxiliaryOperationWhite failed', error)
      }
    },
  },
};
</script>

<style lang="less">
// 公用自定义弹窗样式
@import url("./assets/css/modal.css");
@import url("./assets/css/iconfont.crm.css");
@import url("./assets/css/reset-van-form.css");

body {
  background: #fafafa;

  &.hide {
    overflow: hidden;
  }
}

[class*="van-hairline"]::after {
  border: none;
}

* {
  box-sizing: border-box;
}
.van-empty__image {
  width: 180px;
  height: auto !important;
}
.m_empty {
  padding-top: 140px;
}
#app {
  color: #333;
  -webkit-overflow-scrolling: touch;
  overflow-scrolling: touch;
  display: flex;
  flex-direction: column;

  .app_content {
    flex: 1 1 auto;
    min-height: 0;
    width: 100%;
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  }

  &.has-app-top-nav .app_content {
    min-height: calc(100vh - 44px);
  }

  :deep  .vant-slide-right-leave-to {
    display: none;
  }
}
// .van-popup{
//     width: 100vw ;
//   }

// 电脑端限制最大宽度为375px
// @media screen and (min-width: 562.5px) {
//   #app {
//     max-width: 562.5px;
//     margin: 0 auto;
//     box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
//   }

//   body {
//     background-color: #f5f5f5;
//   }
//   .bar,.ap_btn,.van-nav-bar--fixed,.map-container,.address-list,.bottom-bar.van-popup {
//     left: auto !important;
//     max-width: 562.5px !important;

//   }
//   .van-popup--right{
//     width:  562.5px !important;
//     right: auto;
//   }
// }

.woe_showNav {
  padding-top: 50px !important;
}
.flex-box {
  display: flex;
  align-items: center;
}

.loading-box {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(255, 255, 255, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
}

.dtl-page-foot{
  margin: 15px;
}
</style>
